module.exports = __webpack_public_path__ + "img/中繼站1_BONUS TIME.2aafa471.png";